import { Box, Chip, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { InlineCompareButtons } from "routes/schedule/compare/inline-approval-buttons/inline-compare-buttons"
import { AmendsChangeType } from "authoring/lib/enum/amends-change-type.mjs"
import { getLegislationAmendsKey } from "../amends/lib/constants/legislation-amends-keys.mjs"
import { AuthoringReviewAmendsBlock } from "./authoring-review-amends-block"

export function AuthoringReviewLegislationRow({ item }) {
    const { legislationId, changeType } = item
    const { target, comparisonTarget, legislationLookup } = useBoundContext()
    const legislation = legislationLookup?.get(String(legislationId))
    const amendsKey = getLegislationAmendsKey(legislationId)
    const label = legislation?.title ?? `Reference ${legislationId}`
    const isAdded = changeType === AmendsChangeType.ADDED

    return (
        <Bound acceptId={amendsKey}>
            <Box sx={{ pl: 5, py: 1 }} data-cy={`legislation-review-row-${legislationId}`}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body1">{label}</Typography>
                    <Chip
                        label={isAdded ? "Added" : "Removed"}
                        size="small"
                        color={isAdded ? "success" : "error"}
                        variant="outlined"
                        data-cy={`legislation-change-type-${changeType}`}
                    />
                </Box>
            </Box>
            <Box ml={4} mb={1}>
                <InlineCompareButtons idFromGroup={amendsKey} to={target} from={comparisonTarget} />
            </Box>
            <AuthoringReviewAmendsBlock
                amendsKey={amendsKey}
                subtitle="Change Reference Reason"
                cyPrefix="side-by-side-legislation-amends"
            />
        </Bound>
    )
}
